<template>
  <div>
    <div class="modal fade show" style="display: block">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">ข้อมูล</h5>

            <button type="button" class="close" @click="$emit('close')">
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <!-- หน่วยงาน -->

            <div class="form-group">
              <label>หน่วยงาน</label>

              <select v-model="form.department_id" class="form-control">
                <option v-for="d in departments" :key="d.id" :value="d.id">
                  {{ d.department_name }}
                </option>
              </select>
            </div>

            <!-- ประเภท -->

            <div class="form-group">
              <label>ประเภท</label>

              <select v-model="form.type_id" class="form-control">
                <option v-for="t in types" :key="t.id" :value="t.id">
                  {{ t.type_name }}
                </option>
              </select>
            </div>

            <!-- รายละเอียด -->

            <div class="form-group">
              <label>รายละเอียด</label>

              <textarea
                v-model="form.description"
                class="form-control"
                rows="3"
              ></textarea>
            </div>

            <!-- IP Address -->

            <div class="form-group">
              <label>IP Address</label>

              <input v-model="form.ip_address" class="form-control" />
            </div>

            <!-- ผู้รับผิดชอบ -->
            <div class="form-group">
              <label>ผู้รับผิดชอบ</label>
              <v-select
                v-model="form.user_id"
                :options="users"
                label="name"
                :reduce="(u) => u.id"
                placeholder="เลือกผู้รับผิดชอบ"
                :disabled="disabled || current_user_id !== form.user_id"
              />
              <small
                v-if="current_user_id !== form.user_id"
                class="text-danger"
              >
                เฉพาะผู้รับผิดชอบงานเท่านั้นที่สามารถเปลี่ยนได้
              </small>
            </div>
          </div>

          <div class="modal-footer">
            <button class="btn btn-primary" @click="save">
              <i class="fas fa-save"></i>
              บันทึก
            </button>
            <button class="btn btn-secondary" @click="$emit('close')">
              <i class="fas fa-times"></i>
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-backdrop fade show"></div>
  </div>
</template>
    
    
    <script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    vSelect,
  },

  props: {
    data: Object,
    types: Array,
    departments: Array,
    users: Array,
    current_user_id: Number,

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {},
    };
  },

  watch: {
    data: {
      immediate: true,
      handler(val) {
        this.form = { ...val };
      },
    },
  },

  methods: {
    save() {
      this.$emit("save", this.form);
    },
  },
};
</script>